import { ChangeDetectorRef, Component, HostListener, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { FindUserByNicknevResponseDto } from '../personal-site.interfaces';
import {
  MobilePackageDetails,
  MobilePackageDisplayType,
} from '../../../shared/components/large-mobile-package/large-mobile-package.interfaces';
import { EnvironmentVariablesService } from '../../../core/services/environment-variable-service/environment-variables.service';
import { ExposedEnvironmentVariable } from '../../../../environments/environment-variables';
import { PersonalSiteService } from '../personal-site.service';
import { ContactFormStatus, MapTypeEnum } from '../../../global/global.enums';
import { IMobileServiceResolverData } from '../../mobile-services/mobile-services.interface';
import { MobileServicesService } from '../../mobile-services/mobile-services.service';
import { SelectedPhonePackageService } from '../../devices/selected-phone-package.service';
import { ScrollService } from '../../../shared/services/scroll-service/scroll.service';
import { isPlatformBrowser } from '@angular/common';
import { SHARED_MOBILE_PACKAGES } from '../../../global/mobile-services.constants';

@Component({
  selector: 'ose-vea-personal-site',
  templateUrl: './vea-personal-site.component.html',
  styleUrls: ['./vea-personal-site.component.scss'],
})
export class VeaPersonalSiteComponent implements OnInit {
  @Input() user!: FindUserByNicknevResponseDto;
  @Input() allServicesData!: IMobileServiceResolverData;

  profileImgSrc = '';

  formSubmitText: string = ContactFormStatus.SEND;
  recaptchaKey: string;

  mapTypeEnum = MapTypeEnum;

  packages: MobilePackageDetails[] = SHARED_MOBILE_PACKAGES;

  innerWidth: number;

  constructor(
    private personalSiteService: PersonalSiteService,
    @Inject(PLATFORM_ID) private platformId: object,
    private mobileServicesService: MobileServicesService,
    private selectedPhonePackageService: SelectedPhonePackageService,
    private scrollService: ScrollService,
    private cdr: ChangeDetectorRef,
    private environmentVariablesService: EnvironmentVariablesService
  ) {}

  ngOnInit(): void {
    this.recaptchaKey = this.environmentVariablesService.getVar(ExposedEnvironmentVariable.RECAPTCHA_KEY);

    this.profileImgSrc = this.personalSiteService.getImageSrc(this.user.nicknev);
    if (isPlatformBrowser(this.platformId)) {
      this.innerWidth = window.innerWidth;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.innerWidth = (event.target as Window).innerWidth;
  }
  onFailLoadImage(): void {
    this.profileImgSrc = 'assets/images/sarga_lanyka_uj.webp';
  }

  order(packageItem: MobilePackageDetails): void {
    this.mobileServicesService.order(packageItem);
  }

  getWebsiteUrl(website: string): string {
    if (website.startsWith('https://')) {
      return `//${website.substring(0, 8)}`;
    }
    if (website.startsWith('www')) {
      return `//${website}`;
    }
    if (website.startsWith('www')) {
      return `//www.${website}`;
    }
  }
}
